import { render, staticRenderFns } from "./Typedef2Interface.vue?vue&type=template&id=cd42f2c8&scoped=true&"
import script from "./Typedef2Interface.vue?vue&type=script&lang=js&"
export * from "./Typedef2Interface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd42f2c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
